import {ValueObject} from '@s-ui/domain'

export class VehicleInfoValueObject extends ValueObject {
  /**
   * @param {Object} params.vehicleInfo
   * @param {Array<ImageValueObject>} params.vehicleInfo.images
   * @param {GroupedVersionSpecificationsValueObject} params.vehicleInfo.groupedSpecifications
   * @param {VersionspecificationsValueObject} params.vehicleInfo.specifications
   * @param {EquipmentValueObject} params.vehicleInfo.equipment
   * @param {Number} params.vehicleInfo.year
   * @param {Number} params.vehicleInfo.makeId
   * @param {Number} params.vehicleInfo.modelId
   * @param {Number} params.vehicleInfo.price
   * @param {String} params.vehicleInfo.makeCode
   * @param {String} params.vehicleInfo.modelCode
   * @param {String} params.vehicleInfo.initMarketedDate
   * @param {Array<RelatedVehicleValueObject>} params.vehicleInfo.relatedVehicles
   * @param {String} params.vehicleInfo.technicalDetailsUrl
   * @param {String} params.vehicleInfo.vehicleId
   * @param {String} params.vehicleInfo.uniqueVehicleId
   * */
}
